module.exports = __webpack_public_path__ + "img/express-second-area.3ad794c1.jpg";